<figure class="gallery">
  <slideshow [imageUrls]="images" (onSlideLeft)="onSlide($event)" (onSlideRight)="onSlide($event)"></slideshow>
</figure>
